// ── CTA & Navigation URLs ──────────────────────────────────
export const BOOK_A_DEMO_URL =
  'https://api.leadconnectorhq.com/widget/booking/zJpTzDpQVF3nq65bCeKW'

export const APP_URL = 'https://app.builderlync.com'

export const BIZ411_AFFILIATE_SIGNUP_URL =
  'https://app.builderlync.com/auth/signup?ref=biz411'

export const BIZ411_BOOKING_URL =
  'https://api.leadconnectorhq.com/widget/booking/AU9lFHf7znWkwWWUd8Aw'

export const DEMO_VIDEO_URL =
  'https://drive.google.com/file/d/1p9z6YIdKBqJXkaLNjpVqRgFIGjRQBOPK/preview'

// ── Navigation Links ───────────────────────────────────────
export const NAV_LINKS = [
  { label: 'Features', href: '/features' },
  { label: 'Why BuilderLync', href: '/why-builderlync' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Integrations', href: '/integrations' },
  { label: 'Blog', href: '/blog' },
] as const

// ── Footer Link Groups ────────────────────────────────────
export const FOOTER_LINKS = {
  product: [
    { label: 'Features', href: '/features' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Integrations', href: '/integrations' },
    { label: 'Interactive Demo', href: '/demo' },
  ],
  solutions: [
    { label: 'Roofing CRM', href: '/roofing-crm' },
    { label: 'Roof Estimating', href: '/roof-estimating-software' },
    { label: 'Roof Measurements', href: '/roof-measurement-reports' },
    { label: 'Instant Quotes', href: '/instant-roof-quotes' },
  ],
  compare: [
    { label: 'vs RoofR', href: '/compare/roofr' },
    { label: 'vs AccuLynx', href: '/compare/acculynx' },
    { label: 'vs JobNimbus', href: '/compare/jobnimbus' },
    { label: 'vs Proline', href: '/compare/proline' },
    { label: 'vs RoofLink', href: '/compare/rooflink' },
  ],
  company: [
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
    { label: 'Why BuilderLync', href: '/why-builderlync' },
    { label: 'Blog', href: '/blog' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Cookie Policy', href: '/cookies' },
    { label: 'GDPR', href: '/gdpr' },
  ],
} as const

// ── Social Links ──────────────────────────────────────────
export const SOCIAL_LINKS = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/builderlync', icon: 'linkedin' },
  { label: 'Instagram', href: 'https://www.instagram.com/builderlync/', icon: 'instagram' },
  { label: 'Facebook', href: 'https://www.facebook.com/builderlync', icon: 'facebook' },
  { label: 'YouTube', href: 'https://www.youtube.com/@builderlync', icon: 'youtube' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@builderlync', icon: 'tiktok' },
] as const

// ── Stripe Config ─────────────────────────────────────────
export const STRIPE_CONFIG = {
  starterMonthly: 'price_1SZGuWC2Xy8FpUQJRkVptNDp',
  proMonthly: 'price_1SZGvLC2Xy8FpUQJudabxMvP',
  launchPromo: 'promo_1TYeh7C2Xy8FpUQJIvzKALlQ',
} as const
